<h3 class="title">{{ 'pipeline_step_editor.options.title' | translate }}</h3>
<p
  class="description"
  [innerHTML]="'pipeline_step_editor.options.description' | translate : { categoryName: categoryName }"
></p>

<div class="loading-state" *ngIf="loading" data-cy="options-loading">
  <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
</div>

<div class="empty-state" *ngIf="!loading && items.length === 0 && !canEdit" data-cy="options-empty">
  {{ 'pipeline_step_editor.options.empty' | translate }}
</div>

<ul class="list" *ngIf="!loading && (items.length > 0 || canEdit)" cdkDropList (cdkDropListDropped)="onDrop($event)">
  <li
    class="row"
    [class.row--undefined-label]="item.undefinedLabel"
    *ngFor="let item of items; trackBy: trackByUuid"
    cdkDrag
    [cdkDragDisabled]="!canEdit || pendingRemovalUuid !== null"
    cdkDragLockAxis="y"
    [attr.data-cy]="'option-row'"
  >
    <span class="row__label">
      <span class="row__name">{{ item.name }}</span>
      <span class="row__uuid">{{ item.uuid }}</span>
    </span>

    <span class="row__confirm-text" *ngIf="pendingRemovalUuid === item.uuid">
      {{ 'pipeline_step_editor.options.confirm_delete' | translate }}
    </span>

    <ng-container *ngIf="pendingRemovalUuid !== item.uuid; else confirmActionsTpl">
      <span class="row__actions" *ngIf="canEdit">
        <button type="button" class="icon-button" (click)="translateClicked.emit(item)" data-cy="option-translate">
          <i class="ri-translate-2"></i>
        </button>
        <button
          type="button"
          class="icon-button icon-button--success"
          (click)="thresholdClicked.emit(item)"
          data-cy="option-edit"
        >
          <i class="ri-pencil-line"></i>
        </button>
        <button
          *ngIf="colorActionVisible"
          type="button"
          class="icon-button"
          (click)="colorClicked.emit(item)"
          data-cy="option-color"
        >
          <span *ngIf="item.color; else paletteIcon" class="swatch" data-cy="option-color-swatch">
            <span class="swatch__fill" [style.background-color]="item.color"></span>
          </span>
          <ng-template #paletteIcon><i class="ri-palette-line"></i></ng-template>
        </button>
        <button
          type="button"
          class="icon-button icon-button--danger"
          (click)="requestRemove(item)"
          data-cy="option-remove"
        >
          <i class="ri-close-line"></i>
        </button>
      </span>
    </ng-container>

    <ng-template #confirmActionsTpl>
      <span class="row__actions">
        <button type="button" class="btn btn-flat" (click)="cancelRemove()" data-cy="option-remove-cancel">
          {{ 'button.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmRemove(item)" data-cy="option-remove-confirm">
          {{ 'button.confirm' | translate }}
        </button>
      </span>
    </ng-template>
  </li>

  <li
    class="row row--add-option"
    *ngIf="canEdit"
    data-cy="option-add-row"
    cdkOverlayOrigin
    #addRowOrigin="cdkOverlayOrigin"
    #addRow
  >
    <i class="ri-add-line row--add-option__icon" aria-hidden="true"></i>
    <input
      #optionInput
      class="row--add-option__input"
      type="text"
      [formControl]="optionControl"
      [placeholder]="'pipeline_step_editor.options.add_placeholder' | translate"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown.enter)="onEnter(); $event.preventDefault()"
      (keydown.arrowDown)="onArrowDown($event)"
      (keydown.arrowUp)="onArrowUp($event)"
      (keydown.escape)="onEscape()"
      data-cy="option-add-input"
    />

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="addRowOrigin"
      [cdkConnectedOverlayOpen]="isDropdownOpen && searchTerm.length > 0"
      [cdkConnectedOverlayWidth]="addRow.offsetWidth"
      [cdkConnectedOverlayPositions]="suggestionsOverlayPositions"
      [cdkConnectedOverlayFlexibleDimensions]="true"
      [cdkConnectedOverlayPush]="true"
    >
      <ul class="suggestions" tsInfiniteScroll (reachedBottom)="loadMoreRequested.emit()">
        <li
          class="suggestion"
          *ngFor="let label of suggestions; let i = index; trackBy: trackByUuid"
          [class.suggestion--highlighted]="highlightedIndex === i"
          (mousedown)="$event.preventDefault()"
          (click)="onPickSuggestion(label)"
          data-cy="option-suggestion"
        >
          <span class="suggestion__value">{{ matchedValue(label, searchTerm) }}</span>
          <span class="suggestion__lang">({{ matchedLanguage(label, searchTerm) }})</span>
          <span class="suggestion__uuid">{{ label.uuid }}</span>
        </li>
        <li class="suggestion suggestion--loading" *ngIf="suggestionsLoading" data-cy="option-suggestions-loading">
          <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        </li>
        <li
          class="suggestion suggestion--create"
          [class.suggestion--highlighted]="highlightedIndex === suggestions.length"
          (mousedown)="$event.preventDefault()"
          (click)="onSubmitFreeText()"
          data-cy="option-suggestion-create"
        >
          <i class="ri-add-line suggestion__icon" aria-hidden="true"></i>
          <span>
            {{ 'pipeline_step_editor.options.create_new' | translate : { term: searchTerm } }}
          </span>
        </li>
      </ul>
    </ng-template>
  </li>
</ul>
